import validatorMixin from '@/mixins/validator-mixin.js' // 引入mixin文件
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getServerList} from '@/api/get-data.js'
import {download} from '@/utils/download'

export default {
  name: 'RecordSpace',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 选择器和表格数据
      serversIncludeAll: [],
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: false,
      // 查询条件
      tableQueryParams: {
        serverId: 0,
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 记录编辑
      modalOpen: false,
      modalForm: {
        id: undefined,
        name: undefined,
        localPath: undefined,
        virtualPath: undefined,
        serverId: undefined,
        totalSize: undefined,
        availableSize: undefined,
        usedSize: undefined,
        reservedSize: 0.0
      },
      // 表单校验
      formRules: {
        name: [
          { required: true, message: '录像空间名称不能为空', trigger: 'blur' }
        ],
        localPath: [
          { required: true, message: '本地路径不能为空', trigger: 'blur' }
        ],
        virtualPath: [
          { required: true, message: '虚拟路径不能为空', trigger: 'blur' }
        ],
        serverId: [
          { required: true, message: '服务器不能为空', trigger: 'blur' }
        ],
        reservedSize: [
          { required: true, validator: this.validateFloat, trigger: 'blur' }
        ]
      },
      // 数据导入
      upload: {
        // 是否显示数据导入弹出层
        open: false,
        // 弹出层标题（数据导入）
        title: '数据导入',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的记录数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: '',
        // 上传的地址
        url: '/api/recordSpace/import'
      }
    }
  },
  components: {
  },
  mixins: [
    validatorMixin,
    ssoLoginMixin,
    idNameMixin,
    convertorMixin
  ],
  computed: {
  },
  mounted() {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取服务器列表
      getServerList(() => {
        // 创建服务器列表数组
        this.serversIncludeAll = [{id: 0, name: '全部'}] // 插入‘全部’选项
        this.serversIncludeAll.push(...this.$globalData.servers)

        // 获取录像空间列表
        this.getRecordSpaceList()
      })
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 获取录像空间列表
    getRecordSpaceList() {
      this.loading = true
      this.$http(this.$api.recordSpaceList, this.tableQueryParams).then(
        res => {
          this.loading = false
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
        }
      )
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.pageNum = 1
      this.getRecordSpaceList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.serverName = ''
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getRecordSpaceList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getRecordSpaceList()
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
    },
    // 新增记录
    handleAdd() {
      this.resetModalForm()
      this.modalOpen = true
    },
    // 修改记录
    handleModify(data) {
      this.modalForm.id = data.id
      this.modalForm.name = data.name
      this.modalForm.localPath = data.localPath
      this.modalForm.virtualPath = data.virtualPath
      this.modalForm.serverId = data.serverId
      this.modalForm.totalSize = this.gByteFromByte(data.totalSize)
      this.modalForm.availableSize = this.gByteFromByte(data.availableSize)
      this.modalForm.usedSize = this.gByteFromByte(data.usedSize)
      this.modalForm.reservedSize = this.gByteFromByte(data.reservedSize)
      this.modalOpen = true
    },
    // 重置表单
    resetModalForm() {
      this.modalForm = {
        id: undefined,
        name: '',
        localPath: '',
        virtualPath: '',
        serverId: undefined,
        totalSize: undefined,
        availableSize: undefined,
        usedSize: undefined,
        reservedSize: 0.0
      }
    },
    // 提交新增或修改记录
    handleModalSubmit() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          return
        }

        this.modalOpen = false
        this.modalForm.totalSize = this.byteFromGByte(this.modalForm.totalSize)
        this.modalForm.availableSize = this.byteFromGByte(this.modalForm.availableSize)
        this.modalForm.usedSize = this.byteFromGByte(this.modalForm.usedSize)
        this.modalForm.reservedSize = this.byteFromGByte(this.modalForm.reservedSize)
        this.$http(this.modalForm.id === undefined ? this.$api.addRecordSpace : this.$api.updateRecordSpace, this.modalForm).then(res => {
          this.resetModalForm()
          this.getRecordSpaceList()
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
      })
    },
    // 取消提交记录
    handleModalCancel() {
      this.resetModalForm()
      this.modalOpen = false
    },
    // 删除记录
    handleDelete(row) {
      if (row && row.id) {
        this.$messagebox.confirm('您确定删除当前选中记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.deleteRecordSpace, {
            id: row.id
          }).then(
            res => {
              if (res.code === 200) {
                this.tableQueryParams.pageNum = 1
                this.getRecordSpaceList()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            }
          )
        })
      } else if (this.tableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定删除选中的' + this.tableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let code = 400
          for (let i = 0; i < this.tableSelectedIds.length; ++i) {
            this.$http(this.$api.deleteRecordSpace, {
              id: this.tableSelectedIds[i]
            }).then(res => {
              code = res.code
            }
            )
          }

          if (code === 200) {
            this.tableQueryParams.pageNum = 1
            this.getRecordSpaceList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      }
    },
    // 导入按钮操作
    handleImport() {
      this.upload.title = '数据导入'
      this.upload.open = true
    },
    // 下载模板操作
    handleDownloadTemplate() {
      this.$http(this.$api.downloadRecordSpaceTemplate, null).then(
        res => {
          if (res.code === 200) {
            download(res.data.url)
          }
        })
    },
    // 提交上传文件
    handleFileUploadSubmit() {
      this.$refs.upload.submit()
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true
    },
    // 文件上传成功处理
    handleFileUploadSuccess(res, file, fileList) {
      this.upload.open = false
      this.upload.isUploading = false
      this.$refs.upload.clearFiles()
      this.$alert(res.msg, '导入结果', { dangerouslyUseHTMLString: true })
      this.getRecordSpaceList()
    },
    //  导出按钮操作
    handleExport() {
      this.$confirm('是否确认导出所有记录?', '询问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        this.$http(this.$api.exportRecordSpace, this.tableQueryParams).then(
          function (res) {
            if (res.code === 200) {
              download(res.data.url)
            }
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/recordSpace/RecordSpace.js